// extracted by mini-css-extract-plugin
module.exports = {"button":"SupportButton_button__1Ho9C"};